export const ContentOperationStatus = Object.freeze({
  notStarted: 'not-started',
  inProgress: 'in-progress',
  done: 'done',
  error: 'error'
});
